import Text from '../Text'

const CopyrightSection = ({ data }) => {
  const text = data?.text
  const subText = data?.subText
  const goodflipIcon = data?.goodflipIcon
  const partnerIcon = data?.partnerIcon
  const footerImage = data?.footerImage || ''
  return (
    <section className="w-full bg-white">
      <div className="w-full relative overflow-hidden text-center">
        <div
          className="space-y-1.5 pb-10 flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
          // style={{ backgroundImage: `url(${footerImage})` }}
        >
          <Text tag="div" variant="body" size="small" className="text-[#000]">
            {text}
            {goodflipIcon ? (
              <img
                src={goodflipIcon}
                alt="Goodflip"
                className="w-[67px] h-3 inline-flex ml-1 self-center"
              />
            ) : null}
          </Text>
          <Text
            tag="div"
            variant="body"
            size="small"
            className="text-[#000] self-center"
          >
            {subText}
            {partnerIcon ? (
              <img
                src={partnerIcon}
                alt="Partner"
                className="w-[48px] h-[20px] inline-flex ml-1 self-center"
              />
            ) : null}
          </Text>
        </div>
      </div>
    </section>
  )
}

export default CopyrightSection
